var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-component", attrs: { id: _vm.id } },
    [
      _vm.headerVisibility
        ? _c(
            "v-toolbar",
            { attrs: { dense: "", flat: "" } },
            [
              _vm.deleteButtonVisibility
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        id: _vm.id + "-deleteButton",
                        fab: "",
                        small: "",
                        color: "tesfriRaspberry",
                        disabled: _vm.isDeleteButtonDisabled === true
                      },
                      on: {
                        click: function($event) {
                          return _vm.onRemoveSelected()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-trash-can-outline")])],
                    1
                  )
                : _vm._e(),
              _vm.addButtonVisibility
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        id: _vm.id + "-addButton",
                        fab: "",
                        small: "",
                        color: "tesfriRaspberry",
                        disabled: _vm.isAddButtonDisabled === true
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAddSelected()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { medium: "" } }, [
                        _vm._v("mdi-plus")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _vm.exportButtonVisibility
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        id: _vm.id + "-exportButton",
                        fab: "",
                        small: "",
                        color: "tesfriRaspberry",
                        disabled: _vm.isExportButtonDisabled === true
                      },
                      on: {
                        click: function($event) {
                          return _vm.onExport()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("fas fa-file-csv")])],
                    1
                  )
                : _vm._e(),
              _vm.clearFilterButtonVisibility
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        c: "",
                        fab: "",
                        small: "",
                        color: "tesfriRaspberry"
                      },
                      on: {
                        click: function($event) {
                          return _vm.clearFilters()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-filter-remove-outline")])],
                    1
                  )
                : _vm._e(),
              _vm.toggleCheckboxIsVisibility
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { fab: "", small: "", color: "tesfriRaspberry" },
                      on: {
                        click: function($event) {
                          return _vm.toggleCheckboxVisibility()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("fas fa-tasks")])],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "list-content" }, [
        _c(
          "div",
          { staticClass: "grid-column-configuration" },
          [
            _c("ag-grid-vue", {
              staticClass: "ag-theme-material",
              attrs: {
                id: "myGrid",
                columnDefs: _vm.columnDefs,
                gridOptions: _vm.gridOptions,
                defaultColDef: _vm.defaultColDef,
                rowData: _vm.rowData,
                editType: _vm.editType,
                enableCellTextSelection: true,
                frameworkComponents: _vm.frameworkComponents,
                rowClicked: _vm.onRowClicked,
                rowDoubleClicked: _vm.onRowDoubleClicked,
                overlayLoadingTemplate: _vm.overlayLoadingTemplate,
                overlayNoRowsTemplate: _vm.overlayNoRowsTemplate,
                pagination: _vm.pagination,
                localeText: _vm.localeText,
                pinnedBottomRowData: _vm.pinnedBottomRowData
              },
              on: {
                "grid-ready": _vm.onGridReady,
                gridSizeChanged: _vm.onGridSizeChanged,
                rowSelected: _vm.onRowSelected,
                selectionChanged: _vm.onSelectionChanged,
                rowValueChanged: _vm.onRowValueChanged,
                rowEditingStarted: _vm.onRowEditingStarted,
                rowEditingStopped: _vm.onRowEditingStopped,
                cellEditingStarted: _vm.onCellEditingStarted,
                cellEditingStopped: _vm.onCellEditingStopped,
                columnEverythingChanged: _vm.onColumnEvent,
                columnRowGroupChanged: _vm.onColumnEvent,
                columnValueChanged: _vm.onColumnEvent,
                columnMoved: _vm.onColumnEvent,
                columnVisible: _vm.onColumnEvent,
                columnGroupOpened: _vm.onColumnEvent,
                columnResized: _vm.onColumnEvent,
                columnPinnedCountChanged: _vm.onColumnEvent,
                cellClicked: _vm.onCellClicked,
                rowDataChanged: _vm.onRowDataChanged,
                "model-updated": _vm.onModelUpdated,
                "first-data-rendered": _vm.onFirstDataRendered
              }
            }),
            _c(
              "v-card",
              { staticClass: "column-configuration " },
              [
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  _vm._l(_vm.columns, function(col) {
                    return _c("v-switch", {
                      key: col.id,
                      attrs: { label: col.name, color: "success" },
                      on: {
                        change: function($event) {
                          return _vm.toggleColumnVisibility(col.id)
                        }
                      },
                      model: {
                        value: col.visible,
                        callback: function($$v) {
                          _vm.$set(col, "visible", $$v)
                        },
                        expression: "col.visible"
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }